import _regenerator from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import exports from '@/assets/icons/png/daochu.png';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import Screenfull from '@/components/Screenfull';
import SizeSelect from '@/components/SizeSelect';
// import Search from '@/components/HeaderSearch'
import RuoYiGit from '@/components/RuoYi/Git';
import clearCache from '@/components/RuoYi/clearCache';
import RuoYiDoc from '@/components/RuoYi/Doc';
import TopNav from '@/components/TopNav';
import { getRouters } from '@/api/menu';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    Hamburger: Hamburger,
    Screenfull: Screenfull,
    SizeSelect: SizeSelect,
    RuoYiGit: RuoYiGit,
    RuoYiDoc: RuoYiDoc,
    TopNav: TopNav,
    clearCache: clearCache
  },
  data: function data() {
    return {
      index: 0,
      timer: null,
      dotIndex: null
    };
  },
  created: function created() {
    var _this = this;
    this.getMessageIndex();
    // this.getNoticeIndex()
    /*  this.timer = setInterval(() => {
        this.getMessageIndex()
        this.getNoticeIndex()
      }, 10000)*/
    this.$emitter.on(this.ENUM.NAVBAR_MESSAGE_INDEX_REDUCE, function (data) {
      _this.getMessageIndex();
    });
    /* this.$emitter.on(this.ENUM.NAVBAR_NOTICE_INDEX_REDUCE, (data) => {
       this.getNoticeIndex()
     })*/
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'avatar', 'device', 'name'])), {}, {
    setting: {
      get: function get() {
        return this.$store.state.settings.showSettings;
      },
      set: function set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        });
      }
    },
    topNav: {
      get: function get() {
        return this.$store.state.settings.topNav;
      }
    }
  }),
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    getMessageIndex: function getMessageIndex() {
      var _this2 = this;
      this.$api.sysMessageNum().then(function (res) {
        _this2.index = res.data.total;
      });
    },
    /**
    Todo
    旧数据迁移未同步后端接口，暂时注释 by yinyy 2022-10-09
    getNoticeIndex() {
      this.$api.getNoticeReadIndex().then(res => {
        this.dotIndex = res.data.total
      })
    },
    */
    logout: function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this3 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.$confirm('确定退出系统？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(function () {
                _this3.$store.dispatch('LogOut').then(function () {
                  location.reload();
                });
              });
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }
};